import { Component, Input } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalLayoutComponent } from '../layout/modal-layout.component';

export namespace NModalLayoutMiddle {
    /**
     * Default setup for left side modal
     */
    export const modalConfig: ModalConfig = {
        hasBackdrop: true,
        closeOnNavigation: true,
        minWidth: undefined,
        maxWidth: undefined,
        modalClass: 'p-a-0'
    };

    /** we need a functiojn here cuase app is not yet ready to generate vw classes when const is set */
    export const getWidth = (size: ISizeName): string => (size === 'S' ? '90vw' : '41.2em');
}

@Component({
    selector: 'modal-layout-middle',
    templateUrl: 'modal-layout-middle.html'
})
export class ModalLayoutMiddleComponent extends ModalLayoutComponent {
    @Input()
    sideImage?: string;

    @Input()
    hideClose = false;
}
